import Vue from 'vue';
import 'intersection-observer';

export default Vue.extend({
  data() {
    return {
      innerHeight: window.innerHeight,
      innerWidth: window.innerWidth,
      scrollX: window.scrollX,
      scrollY: window.scrollY,
      io: new IntersectionObserver(this.ioCallback),
      mo: new MutationObserver(this.moCallback),
    };
  },
  created() {
    window.addEventListener('resize', this.rafCallback);
    window.addEventListener('scroll', this.rafCallback);
  },
  methods: {
    createCustomIO(options) {
      return new IntersectionObserver(this.ioCallback, options);
    },
    createCustomMO() {
      return new MutationObserver(this.moCallback);
    },
    ioCallback(entries) {
      entries.forEach((entry) => {
        const target = entry.target;

        if (entry.isIntersecting && typeof target.onIntersect === 'function') {
          target.onIntersect(entry);
        } else if (!entry.isIntersecting && typeof target.onOutersect === 'function') {
          target.onOutersect(entry);
        }
      });
    },
    moCallback(mutations) {
      mutations.forEach((mutation) => {
        const target = mutation.target;
        const type = mutation.type;

        if (type === 'childList' && typeof target.onChildListModification === 'function') {
          target.onChildListModification();
        } else if (type === 'attributes' && typeof target.onAttributesModification === 'function') {
          target.onAttributesModification();
        } else if (type === 'characterData' && typeof target.onCharacterDataModification === 'function') {
          target.onCharacterDataModification();
        }
      });
    },
    rafCallback() {
      if (this.raf) {
        window.cancelAnimationFrame(this.raf);
        this.raf = undefined;
      }

      this.raf = window.requestAnimationFrame(() => {
        this.innerHeight = window.innerHeight;
        this.innerWidth = window.innerWidth;
        this.scrollX = window.scrollX;
        this.scrollY = window.scrollY;
      });
    },
  },
});
